import { Link, useMatch } from 'react-router-dom';
import { twJoin } from '@utils/twMerge';

type MenuSubSectionProps = {
  name: string;
  title: string;
  path: string;
  disabled?: boolean;
};

export const MenuSubSection = ({
  name,
  title,
  path,
  disabled,
}: MenuSubSectionProps) => {
  const match = useMatch(path);
  const active = match?.pattern.path.includes(path);

  return (
    <li
      data-testid={'MenuSubSection-' + name}
      className='ml-1 flex pl-2'
      key={name}
    >
      <div className='relative border-l border-brightGray pl-[1.4rem]'>
        <div
          className={twJoin(
            'circle absolute -left-[3px] top-1/2 h-[5px] w-[5px] -translate-y-1/2 transform rounded-full',
            active ? 'bg-dimGray' : 'bg-brightGray'
          )}
        />
        <Link
          to={path}
          className={twJoin(
            'text-1624 block my-2 whitespace-nowrap pl-2 font-medium',
            active ? 'text-chineseBlack' : 'text-dimGray',
            disabled && 'pointer-events-none opacity-30'
          )}
        >
          {title}
        </Link>
      </div>
    </li>
  );
};
